import { Form } from "antd";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { ContractsVirtualAppProfilesTable } from "./ContractsVirtualAppProfilesTable";

export const ContractsVirtualAppProfilesTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return (
        <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
                const siteId = getFieldValue("siteId");
                const centralized = getFieldValue("centralized");

                return id ? (
                    <Form.Item key={`${field.name}FormItem`} name={field.name}>
                        <ContractsVirtualAppProfilesTable
                            key={field.name}
                            readOnly={readOnly}
                            siteId={siteId}
                            centralized={centralized}
                            id={Number(id)}
                        />
                    </Form.Item>
                ) : (
                    <CreateTablePlaceholderComponent />
                );
            }}
        </Form.Item>
    );
};
